import React from 'react';
import './style.scss';
import { PlanogramData } from './hooks';
import { IMAGE_URL } from '../../../../config/envConf';

interface Props {
    planogramList: PlanogramData[][];
    // eslint-disable-next-line no-unused-vars
    renderModalDelete: (item: PlanogramData) => React.ReactElement;
    // eslint-disable-next-line no-unused-vars
    renderModalUpdate: (item: PlanogramData) => React.ReactElement;
}

function RenderSixSquareStyle(props: Props) {
  const {
    planogramList, renderModalUpdate, renderModalDelete,
  } = props;
  return (
    <div>
      {planogramList.map((data, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="w-100 d-flex" key={index}>
          <div style={{ height: '40px', backgroundColor: '#F3F4F8' }} className="pe-4 pe-xl-5" />
          <div className="flex-grow-1 position-relative" style={{ minWidth: 0 }}>
            <div
              style={{
                height: '40px', backgroundColor: '#F3F4F8', width: '100%', position: 'absolute', top: 0, zIndex: -1,
              }}
            />
            <div className="planogram-row h-100">
              {data.map((item, i) => (
                <div key={item.id} style={{ minWidth: '200px', maxWidth: '200px', height: '100%' }}>
                  <div
                    style={{ height: '40px', backgroundColor: '#F3F4F8' }}
                    className="fz-14 flexible-center text-center color-placeholder"
                  >
                    {item.apCode}
                  </div>
                  <div
                    className="p-2 h-100"
                    style={i === 0 ? { borderRight: '2px solid #F3F4F8', borderLeft: '2px solid #F3F4F8' } : { borderRight: '2px solid #F3F4F8' }}
                  >
                    <div className="d-flex justify-content-end align-items-center">
                      {renderModalDelete(item)}
                      {renderModalUpdate(item)}
                    </div>
                    <div className="flexible-center mb-3 mt-2" style={{ height: '150px' }}>
                      <img src={`${IMAGE_URL}${item.productImage}`} alt="productImg" width={100} />
                    </div>
                    <div className="fz-14 planogram-desc">{item.productName}</div>
                    <div className="d-flex justify-content-between fz-14 mt-2">
                      <div>
                        {`$${item.price}`}
                      </div>
                      <div>{`Qty: ${item.quantity}`}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ height: '40px', backgroundColor: '#F3F4F8' }} className="pe-4 pe-xl-5" />
        </div>
      ))}
    </div>
  );
}

export default React.memo(RenderSixSquareStyle);
